import React from 'react'

import { LoaderProps } from '@customTypes'

import { SVG } from './components'

const getDisplayProgress = (progress?: number) => {
  if (!progress) return progress

  if (progress > 100) return 100
  if (progress < 0) return 0

  return progress
}

export const RingLoader: React.FC<LoaderProps> = ({
  useProgressDisplay,
  progress,
  ...props
}) => {
  const displayProgress = getDisplayProgress(progress)

  return (
    <SVG {...props} progress={displayProgress}>
      <circle
        r="0.42em"
        width="1em"
        height="1em"
        strokeWidth="0.16em"
        fill="transparent"
        cx="0.5em"
        cy="0.5em"
      />
      {useProgressDisplay && (
        <circle
          r="0.42em"
          width="1em"
          height="1em"
          strokeWidth="0.16em"
          fill="transparent"
          cx="0.5em"
          cy="0.5em"
        />
      )}
    </SVG>
  )
}
